<template>
  <router-view />
</template>

<script setup lang="ts">
//
</script>

<style>
html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Roboto', sans-serif;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-theme-primary), 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-theme-primary), 0.8);
}

::selection {
  background: rgba(var(--v-theme-primary), 0.3);
  color: rgb(var(--v-theme-on-surface));
}

.v-btn:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}
</style>
